import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        width: "100%",
        height: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        background: theme.palette.primary.main,
    },
    titleContainer: {
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    title: {
        color: theme.palette.info.main,
        fontWeight: "600 !important",
    },
    graphContainer: {
        width: "100%",
        height: "48vh !important",
        position: "relative",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        "@media (min-width: 1600px)": {
            height: "38vh !important",
            gridTemplateColumns: "1fr 1fr 1fr",
        },
        rowGap: theme.spacing(2),
        overflowY: "scroll",
        padding: theme.spacing(4),
        marginTop: theme.spacing(5),
    },
    barGraphWrapper: {
        height: "32vh !important",
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
    graphTitle: {
        textAlign: "center",
    },
}));
